export const norwegianTranslations: Record<string, string> = {
  // Navigation
  'nav.home': 'Hjem',
  'nav.shop': 'Produkter',
  'nav.about': 'Om oss',
  'nav.contact': 'Kontakt',
  'nav.blog': 'Blogg',
  'nav.trackOrder': 'Spor bestilling',

  // Hero
  'hero.badge.pdrn': 'PDRN-teknologi',
  'hero.badge.glassSkin': 'Glass Skin-effekt',
  'hero.badge.korean': 'Koreansk innovasjon',
  'hero.title': 'PDRN hudpleie — Koreansk lakse-DNA',
  'hero.subtitle': 'Forvandle huden din med klinisk bevist PDRN-serum, sheet-masker og kapsulkrem. Oppnå Glass Skin-effekten med premium PDRN hudpleieprodukter basert på lakse-DNA.',
  'hero.cta': 'Utforsk kolleksjonen',
  'hero.ctaSurvey': 'Gratis hudanalyse',
  'hero.socialProof': 'Elsket av over 10 000 hudpleieentusiaster',
  'survey.bubbleTooltip': 'Personlig tilpasset rutine + 10 % rabatt',

  // Products
  'products.title': 'Vår kolleksjon',
  'products.subtitle': 'Premium koreansk hudpleie med PDRN-teknologi',
  'products.addToCart': 'Legg i handlekurven',
  'products.buyNow': 'Kjøp nå',
  'products.soldOut': 'Utsolgt',
  'products.save': 'Tilbud',
  'products.viewDetails': 'Se detaljer',
  'products.noProducts': 'Ingen produkter tilgjengelige for øyeblikket',
  'products.selectSize': 'Velg størrelse',
  'products.quantity': 'Antall',
  'products.inStock': 'På lager',
  'products.outOfStock': 'Utsolgt',

  // Upsell
  'upsell.title': 'Fullfør rutinen',
  'upsell.savings': 'Spar med det komplette settet',
  'upsell.cta': 'Oppgrader til komplett sett',
  'upsell.includes': 'Komplett hudpleierutine i én pakke',
  'upsell.badge': 'Fullfør rutinen',
  'upsell.saveBadge': 'Spar {amount}!',
  'upsell.whyBundle': 'Hvorfor velge det komplette settet?',
  'upsell.whyBundleDesc': 'Hvert trinn bygger på det forrige for maksimale resultater',
  'upsell.includesSerum': 'Rosa glød-serum',
  'upsell.includesCream': 'Smart kapsulkrem',
  'upsell.includesMasks': 'Pakke med 10 masker',
  'upsell.separatelyPrice': 'Enkeltvis: {amount}',
  'upsell.serumTooltip': 'Lett PDRN-serum som fremmer kollagenproduksjon, glatter rynker og gir øyeblikkelig Glass Skin-glød.',
  'upsell.creamTooltip': 'Innovativ kapsulformel med PDRN, 5 % niacinamid og hydrolysert kollagen for dyp fuktighet og fasthet.',
  'upsell.masksTooltip': '10 sheet-masker fylt med konsentrert PDRN-serum for intensiv behandling som gir øyeblikkelig Glass Skin-effekt.',

  // Cart
  'cart.title': 'Handlekurv',
  'cart.empty': 'Handlekurven din er tom',
  'cart.itemCount': '{count} varer i handlekurven',
  'cart.total': 'Totalt',
  'cart.checkout': 'Til kassen',
  'cart.continueShopping': 'Fortsett å handle',
  'cart.addedToCart': 'Lagt i handlekurven!',
  'cart.couponPlaceholder': 'Rabattkode',
  'cart.applyCoupon': 'Bruk',
  'cart.couponApplied': 'Rabatt brukt!',
  'cart.couponError': 'Ugyldig kode',
  'cart.removeCoupon': 'Fjern',
  'cart.freeShippingUnlocked': 'Du har fått gratis frakt!',
  'cart.freeShippingRemaining': 'Legg til {amount} til for gratis frakt',
  'cart.freeShippingThreshold': 'Gratis frakt på bestillinger over {amount}',
  'cart.completeRoutine': 'Fullfør rutinen din',
  'cart.bundleSave': 'Spar {percent}%',
  'cart.quickAdd': 'Legg til',

  'promo.b2g1': '🎁 Legg til 3 produkter i handlekurven — 1 er GRATIS!',
  'promo.b2g1Cart': '🎁 2+1-tilbud aktivert! For hver 3 produkter er 1 GRATIS!',
  'promo.b2g1CartHint': 'Legg til {count} til for et GRATIS produkt! (3 produkter kreves)',
  'promo.b2g1Saving': 'Du sparer {amount} — billigste produkt er GRATIS!',
  'promo.freeItem': '🎁 GRATIS i kampanjen',

  // About
  'about.title': 'Om oss',
  'about.subtitle': 'Vitenskapen bak koreansk skjønnhet',
  'about.pdrnTitle': 'Vitenskapen bak PDRN-hudpleie',
  'about.pdrnDescription': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — en revolusjonerende ingrediens i koreansk hudpleie. Våre PDRN-hudpleieprodukter fremmer cellefornyelse for en perfekt Glass Skin-effekt.',
  'about.glassSkinDesc': 'Oppnå den ettertraktede koreanske Glass Skin-effekten med øyeblikkelig glød.',
  'about.hydrationDesc': 'Dyp fuktighet som varer hele dagen, med klinisk bevist fuktighetsbevaring.',
  'about.antiAgingDesc': 'Øk kollagenproduksjonen naturlig for fastere og yngre hud.',

  // Footer
  'footer.copyright': '© 2026 PDRN SKIN. Alle rettigheter reservert.',
  'footer.freeShipping': 'Gratis frakt over {amount} (Norge)',
  'footer.securePayment': 'Sikker betaling',
  'footer.support': 'Kundeservice 24/7',
  'footer.description': 'Premium koreansk hudpleie med revolusjonerende PDRN-teknologi. Opplev Glass Skin-effekten med våre vitenskapelige produkter.',
  'footer.sheetMasks': 'Sheet-masker',
  'footer.serum': 'Serum',
  'footer.cream': 'Krem',
  'footer.bundle': 'Komplett sett',
  'footer.faq': 'Vanlige spørsmål',
  'footer.shippingReturns': 'Frakt og retur',
  'footer.privacyPolicy': 'Personvernregler',
  'footer.termsOfService': 'Vilkår for bruk',
  'footer.returnPolicy': 'Returpolicy',
  'footer.contactSupport': 'Vi er her for deg — spørsmål, ordrestatus, problemer eller hjelp med et kjøp. Kontakt vår kundeservice på',

  // Common
  'common.verified': 'Verifisert',
  'common.before': 'Før',
  'common.after': 'Etter',
  'common.loading': 'Laster...',
  'common.error': 'En feil oppstod',
  'common.noPhotoShared': 'Kunden delte ikke bilde',

  // Media
  'media.videoPlaceholder': 'Plassholder for video',
  'media.gifPlaceholder': 'Plassholder for GIF',
  'media.imagePlaceholder': 'Plassholder for bilde',

  // Feature
  'feature.hydration': '+100 % fuktighet',
  'feature.glassSkin': 'Glass Skin-effekt',
  'feature.antiAging': 'Anti-aging',
  'feature.collagen': 'Kollagenboost',
  'feature.brightening': 'Lysgjørende',

  // Product
  'product.howToUse': 'Bruksanvisning',
  'product.ingredients': 'Nøkkelingredienser',
  'product.reviews': 'Kundeanmeldelser',
  'product.results': 'Ekte resultater',
  'product.realResults': 'Ekte resultater',
  'product.beforeAfter': 'Før og etter',
  'product.faqTitle': 'Spørsmål og svar',
  'product.mediaGallery': 'Mediegalleri',
  'product.freeShipping': 'Gratis frakt fra {amount}',
  'product.secureCheckout': 'Sikker betaling',
  'product.returns': 'Retur innen 7 dager',
  'product.koreanFormula': 'Koreansk formel',
  'product.premiumIngredients': 'Premium ingredienser',
  'product.backHome': 'Tilbake til forsiden',
  'product.notFound': 'Produktet ble ikke funnet',
  'product.bestValue': 'Best verdi',
  'product.bestseller': 'Bestselger',
  'product.reviewCount': '({count} anmeldelser)',
  'product.crueltyFree': 'Ikke testet på dyr',
  'product.youMayAlsoLike': 'Du vil kanskje også like',
  'product.completeRoutine': 'Fullfør hudpleierutinen din',
  'product.moneyBack': 'Pengene tilbake innen 7 dager',
  'product.dermatologistTested': 'Dermatologisk testet',
  'product.payWith': 'Sikker betaling med',
  'product.specsTitle': 'Produktdetaljer',
  'product.specsVolume': 'Størrelse',
  'product.specsSkinType': 'Hudtype',
  'product.specsTested': 'Tester',
  'product.specsClinicallyTested': 'Klinisk testet',
  'product.specsShelfLife': 'Holdbarhet',
  'product.specsFreeOf': 'Fri for parabener, sulfater og ftalater',
  'product.satisfactionGuarantee': '100 % fornøydhetsgaranti',
  'product.satisfactionDesc': 'Prøv risikofritt med vår garanti for pengene tilbake innen 7 dager',

  // Before & After
  'beforeAfter.customer1': 'Ingrid',
  'beforeAfter.customer2': 'Noor',
  'beforeAfter.customer3': 'Amina',
  'beforeAfter.weeks3': '3 ukers bruk',
  'beforeAfter.weeks8': '8 ukers bruk',
  'beforeAfter.weeks12': '12 ukers bruk',

  // Mobile Cart
  'mobileCart.findRoutine': 'Finn rutinen din',

  // Survey
  'survey.buttonText': 'Finn rutinen din',
  'survey.title': 'Hudanalyse',
  'survey.subtitle': 'Svar på noen korte spørsmål, så finner jeg den perfekte rutinen for deg',
  'survey.question': 'Spørsmål',
  'survey.back': 'Tilbake',
  'survey.next': 'Neste',
  'survey.getResults': 'Se resultater',
  'survey.resultsTitle': 'Rutinen jeg har tilpasset for deg',
  'survey.resultsSubtitle': 'Basert på det du fortalte meg, er dette det jeg anbefaler for deg',
  'survey.yourProfile': 'Hudprofilen din',
  'survey.recommended': 'Anbefalt for deg',
  'survey.bundleNote': 'For best mulige resultater anbefaler jeg det komplette settet',
  'survey.howToUse': 'Rutinen jeg har tilpasset for deg',
  'survey.morning': 'Morgen',
  'survey.evening': 'Kveld',
  'survey.expectedResults': 'Forventede resultater',
  'survey.week': 'Uke',
  'survey.weeks': 'Uker',
  'survey.personalTips': 'Mine tips til deg',
  'survey.retake': 'Ta på nytt',
  'survey.shopNow': 'Kjøp nå',
  'survey.errorTooMany': 'For mange forespørsler. Prøv igjen senere.',
  'survey.errorGeneric': 'Noe gikk galt. Prøv igjen.',
  'survey.yourPersonalizedRoutine': 'Rutinen jeg har tilpasset for deg',
  'survey.treatmentPlan': 'Anbefalt behandlingsvarighet',
  'survey.addRoutineToCart': 'Legg rutinen i handlekurven',
  'survey.satisfactionGuarantee': '100 % fornøydhetsgaranti',
  'survey.maybeLater': 'Kanskje senere',
  'survey.continueSurvey': 'Fortsett med spørreskjemaet',
  'survey.addedToCart': 'Produktene er lagt i handlekurven!',
  'survey.personalizedRoutine': 'Den tilpassede rutinen din er klar',
  'survey.errorAddingToCart': 'Feil ved tillegging i handlekurven',
  'survey.exclusiveDiscount': '10 % eksklusiv rabatt for deg!',
  'survey.couponCopied': 'Kupongkoden er kopiert!',
  'survey.useAtCheckout': 'Bruk koden SURVEY10 ved betaling for å få 10 % rabatt',
  'survey.bestDeal': 'Det beste tilbudet jeg fant for deg!',
  'survey.separatePrice': 'Enkeltvis',
  'survey.yourPrice': 'Din pris',
  'survey.youSave': 'Du sparer',
  'survey.upgradeOption': 'Vil du ha enda bedre resultater?',
  'survey.upgradeToBundle': 'Oppgrader til komplett rutine',
  'survey.upgradeSave': 'Spar {amount} med det komplette settet',
  'survey.addSingleToCart': 'Legg i handlekurven',

  // Survey loading messages
  'survey.loading.analyzing': 'Analyserer hudprofilen din...',
  'survey.loading.planning': 'Planlegger en personlig tilpasset behandling...',
  'survey.loading.matching': 'Finner de perfekte produktene for deg...',
  'survey.loading.finalizing': 'Nesten ferdig...',

  // Survey questions
  'survey.q1.question': 'Hva er hudtypen din?',
  'survey.q1.dry': 'Tørr — huden min føles ofte stram',
  'survey.q1.oily': 'Fet — glansete, spesielt i pannen og på nesen',
  'survey.q1.combination': 'Kombinert — fet panne og nese, tørre kinn',
  'survey.q1.normal': 'Normal — balansert, uten betydelige problemer',
  'survey.q2.question': 'Hva plager deg mest med huden din?',
  'survey.q2.aging': 'Rynker og fine linjer',
  'survey.q2.acne': 'Akne og uren hud',
  'survey.q2.dullness': 'Matt hud og ujevn hudtone',
  'survey.q2.hyperpigmentation': 'Mørke flekker og hyperpigmentering',
  'survey.q3.question': 'Hvor sensitiv er huden din?',
  'survey.q3.very': 'Veldig sensitiv — reagerer på de fleste produkter',
  'survey.q3.somewhat': 'Noe sensitiv — reaksjoner av og til',
  'survey.q3.not': 'Ikke sensitiv — tåler de fleste produkter',
  'survey.q4.question': 'Hvor fuktig er huden din?',
  'survey.q4.veryDry': 'Veldig tørr — trenger fuktighet hele tiden',
  'survey.q4.somewhatDry': 'Litt tørr — trenger fuktighet jevnlig',
  'survey.q4.balanced': 'Balansert — verken tørr eller fet',
  'survey.q4.wellHydrated': 'Godt fuktet — fast og sunn',
  'survey.q5.question': 'Hva er aldersgruppen din?',
  'survey.q5.under25': 'Under 25',
  'survey.q5.25to35': '25–35',
  'survey.q5.35to45': '35–45',
  'survey.q5.over45': 'Over 45',
  'survey.q6.question': 'Hvordan vil du beskrive din nåværende hudpleierutine?',
  'survey.q6.minimal': 'Minimal — bare rens og fuktighet',
  'survey.q6.basic': 'Grunnleggende — rens, toner, fuktighet',
  'survey.q6.moderate': 'Moderat — inkludert serumer og behandlinger',
  'survey.q6.extensive': 'Omfattende — full koreansk hudpleierutine',
  'survey.q7.question': 'Hvordan vil du beskrive hudteksturen din?',
  'survey.q7.smooth': 'Glatt og jevn',
  'survey.q7.rough': 'Ru med ujevn tekstur',
  'survey.q7.uneven': 'Ujevn med noen ujevnheter',
  'survey.q7.bumpy': 'Knudrete med synlige porer',
  'survey.q8.question': 'Hva er hovedmålet ditt med hudpleie?',
  'survey.q8.glow': 'Oppnå den koreanske gløden',
  'survey.q8.antiAging': 'Redusere aldringstegn',
  'survey.q8.hydration': 'Dyp fuktighet',
  'survey.q8.all': 'Alt ovenfor',

  // Trust Strip
  'trust.clinicallyTested': 'Klinisk testet',
  'trust.happyCustomers': '10 000+ fornøyde kunder',
  'trust.labFormula': 'Koreansk laboratorieformel',
  'trust.moneyBack': 'Pengene tilbake innen 7 dager',

  // Science
  'science.title': 'PDRN fra lakse-DNA — vitenskapelig dokumentert',
  'science.subtitle': 'PDRN er klinisk bevist med fagfellevurderte studier',
  'science.citation1': '"PDRN fremmer sårheling og vevsregenerasjon gjennom aktivering av adenosin A2A-reseptoren."',
  'science.source1': '— Journal of Cosmetic Dermatology, 2020',
  'science.citation2': '"PDRN fra laks forbedrer fuktighet og elastisitet betydelig, og reduserer rynkedybde i kliniske studier."',
  'science.source2': '— International Journal of Molecular Sciences, 2021',

  // Science Inside
  'scienceInside.title': 'Vitenskapen inni',
  'scienceInside.subtitle': 'Hvorfor denne formelen virker — to kraftige motorer i ett serum',
  'scienceInside.peptides.title': 'Peptider — Ingeniørene',
  'scienceInside.peptides.subtitle': '"Smarte budbringere, ikke en magisk krem"',
  'scienceInside.peptides.point1': 'Korte aminosyrekjeder som signaliserer huden din til å oppføre seg som ung, fornyet hud',
  'scienceInside.peptides.point2': 'Støtter et fastere utseende og mindre synlige fine linjer over tid',
  'scienceInside.peptides.point3': 'Styrker hudbarrieren — huden føles mindre «skjør» og mindre reaktiv',
  'scienceInside.peptides.point4': 'Smart effekt som forsterkes ved jevn bruk, ikke et endagsunder',
  'scienceInside.pdrn.title': 'PDRN — Gjenoppbyggeren',
  'scienceInside.pdrn.subtitle': 'Den ledende reparasjonsingrediensen i K-Beauty-verdenen',
  'scienceInside.pdrn.point1': 'DNA-fragmenter som snakker fornyelsens og reparasjonens språk',
  'scienceInside.pdrn.point2': 'Støtter hudkvaliteten og fremmer et sunt og tettere utseende',
  'scienceInside.pdrn.point3': 'Beroligende for stresset eller reaktiv hud — mindre rødhet, mer balanse',
  'scienceInside.pdrn.point4': 'I serumet: jevn og smart forbedring — ikke dramatisk over natten',
  'scienceInside.combo.title': 'To motorer, ett serum',
  'scienceInside.combo.subtitle': 'Øyeblikkelig glød + kumulativ anti-aging',
  'scienceInside.combo.point1': 'Motor 1: "Se det nå" — fuktighet, lysrefleksjon, jevnere tekstur',
  'scienceInside.combo.point2': 'Motor 2: "Se det over tid" — fasthet, elastisitet, reparasjon',
  'scienceInside.combo.point3': 'Den øyeblikkelige "wow"-effekten gjør at du fortsetter — peptidene og PDRN gjør resten',
  'scienceInside.combo.point4': 'Resultatet: hud som ser tett, rolig og polert ut',
  'scienceInside.tagline': 'Peptider bygger og styrker. PDRN reparerer og beroliger. Sammen gir de huden din både øyeblikkelig glød og fornyelse over tid.',

  // Science Inside — Default
  'scienceInside.default.subtitle': 'Vitenskapen bak PDRN — hvordan den forvandler huden din innenfra',
  'scienceInside.default.tagline': 'PDRN aktiverer hudens naturlige reparasjonsmekanisme, fremmer cellefornyelse og dyp fuktighet allerede fra første bruk.',

  // Default product FAQ
  'productContent.default.faq1.q': 'Hva er PDRN, og hvordan virker det?',
  'productContent.default.faq1.a': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA. Det aktiverer hudens naturlige reparasjonsmekanisme gjennom adenosin A2A-reseptoren, og fremmer cellefornyelse, kollagenproduksjon og dyp fuktighet.',
  'productContent.default.faq2.q': 'Er produktet egnet for sensitiv hud?',
  'productContent.default.faq2.a': 'Ja! Formlene våre er dermatologisk testet, dyrevennlige og fri for parabener, sulfater og ftalater. De er utviklet for å være skånsomme mot alle hudtyper, inkludert sensitiv hud.',
  'productContent.default.faq3.q': 'Hvor lang tid tar det før man ser resultater?',
  'productContent.default.faq3.a': 'De fleste brukere merker forbedret fuktighet og synlig glød allerede fra første bruk. For optimale resultater på fine linjer og hudtekstur anbefales jevn bruk i 4–8 uker.',

  // Science Inside — Masks
  'scienceInside.masks.subtitle': 'Hvordan tre kraftige ingredienser samarbeider i hver sheet-maske',
  'scienceInside.masks.tagline': 'PDRN reparerer på cellenivå. Vitamin B12 lyser opp. Niacinamid styrker. 20 minutter — det er alt huden din trenger for å absorbere alt.',
  'scienceInside.masks.card1.title': 'PDRN + Vitamin B12 — Det lysende paret',
  'scienceInside.masks.card1.subtitle': 'Cellereparasjon møter synlig glød',
  'scienceInside.masks.card1.point1': 'PDRN aktiverer cellefornyelse mens Vitamin B12 gir en øyeblikkelig lysende effekt',
  'scienceInside.masks.card1.point2': 'Sammen behandler de matthet ved kilden — ikke bare overfladisk glød',
  'scienceInside.masks.card1.point3': 'B12 er en bevist hudpleiende ingrediens som jevner ut hudtonen over tid',
  'scienceInside.masks.card1.point4': 'Paret virker i synergi — PDRN fornyer, B12 lyser opp',
  'scienceInside.masks.card2.title': 'Niacinamid — Barriere-byggeren',
  'scienceInside.masks.card2.subtitle': 'Styrker, balanserer, beskytter',
  'scienceInside.masks.card2.point1': 'Styrker hudbarrieren for å låse inn fuktighet og hindre irritanter',
  'scienceInside.masks.card2.point2': 'Reduserer synlig porestørrelse og regulerer overflødig talg',
  'scienceInside.masks.card2.point3': 'Reduserer rødhet og beroliger betennelse — ideelt for sensitiv hud',
  'scienceInside.masks.card2.point4': 'Virker i alle lag av huden for forbedret tekstur, tone og motstandsdyktighet',
  'scienceInside.masks.card3.title': 'Maskeeffekten — 20 minutter med dyp absorpsjon',
  'scienceInside.masks.card3.subtitle': 'Hvorfor en sheet-maske er bedre enn et vanlig serum',
  'scienceInside.masks.card3.point1': 'Sheet-masken skaper et lukket miljø som forhindrer fordamping',
  'scienceInside.masks.card3.point2': 'Aktive ingredienser leveres i høyere konsentrasjon enn daglige serumer',
  'scienceInside.masks.card3.point3': 'Dyp absorpsjon — ingrediensene trenger dypere takket være langvarig kontakt med huden',
  'scienceInside.masks.card3.point4': 'Øyeblikkelige og synlige resultater: fyldigere, mer fuktet hud med glød allerede etter én bruk',

  // Science Inside — Cream
  'scienceInside.cream.subtitle': 'Tre avanserte teknologier som virker om natten for å forvandle huden din',
  'scienceInside.cream.tagline': 'Kollagen bygger opp struktur. Ceramider beskytter barrieren. Smarte kapsler leverer alt gjennom natten — slik at du våkner med fornyet og fastere hud.',
  'scienceInside.cream.card1.title': 'Hydrolysert kollagen — Strukturen',
  'scienceInside.cream.card1.subtitle': 'Bygger opp innenfra og ut',
  'scienceInside.cream.card1.point1': 'Brutt ned til små fragmenter som faktisk kan trenge inn i huden — ikke bare ligge på overflaten',
  'scienceInside.cream.card1.point2': 'Støtter hudens strukturmatriks for forbedret fasthet og elastisitet',
  'scienceInside.cream.card1.point3': 'Hjelper med å redusere synligheten av fine linjer ved å fylle ut innenfra',
  'scienceInside.cream.card1.point4': 'Virker med hudens naturlige kollagenproduksjon — styrker, ikke erstatter',
  'scienceInside.cream.card2.title': 'Ceramidkompleks — Beskytteren',
  'scienceInside.cream.card2.subtitle': 'Hudens naturlige beskyttelse, forsterket',
  'scienceInside.cream.card2.point1': 'Ceramider utgjør 50 % av hudens naturlige barriere — vi etterfyller det som går tapt med alderen',
  'scienceInside.cream.card2.point2': 'Låser inn fuktighet opptil 72 timer — ingen mer tørrhet og stramhet om natten',
  'scienceInside.cream.card2.point3': 'Beskytter mot miljøskader: forurensning, tørr luft, temperatursvingninger',
  'scienceInside.cream.card2.point4': 'Styrker barrieren slik at andre aktive ingredienser virker mer effektivt',
  'scienceInside.cream.card3.title': 'Smart kapselteknologi — Gradvis frigjøring',
  'scienceInside.cream.card3.subtitle': 'Aktive ingredienser leveres gjennom hele natten',
  'scienceInside.cream.card3.point1': 'Mikrokapsler brytes ned gradvis og frigjør aktive ingredienser over 8 timer',
  'scienceInside.cream.card3.point2': 'Forhindrer nedbrytning av ingredienser — de forblir potente til de frigjøres',
  'scienceInside.cream.card3.point3': 'Huden din får en jevn strøm av næring i stedet for én stor dose som avtar',
  'scienceInside.cream.card3.point4': 'Våkn opp med fornyet og fuktig hud — kapslene har gjort jobben mens du sov',

  // Science Inside — Bundle
  'scienceInside.bundle.subtitle': 'Hvorfor tre produkter sammen gir resultater som ingen enkeltstående produkt kan',
  'scienceInside.bundle.tagline': 'Maskene renser og nærer. Serumet reparerer og lyser opp. Kremen låser alt inne. Tre trinn, ett system — 24 timer med kontinuerlig hudforvandling.',
  'scienceInside.bundle.card1.title': 'Tre trinn, ett system',
  'scienceInside.bundle.card1.subtitle': 'Hvert produkt forbereder huden for neste trinn',
  'scienceInside.bundle.card1.point1': 'Trinn 1: Sheet-masker renser dypt og tilfører konsentrert PDRN + Vitamin B12',
  'scienceInside.bundle.card1.point2': 'Trinn 2: Serumet reparerer, strammer opp og gir Glass Skin-effekten',
  'scienceInside.bundle.card1.point3': 'Trinn 3: Kremen låser alt inne med kollagen, ceramider og kapsler med gradvis frigjøring',
  'scienceInside.bundle.card1.point4': 'Sammen: en komplett rutine der hvert trinn forsterker det forrige',
  'scienceInside.bundle.card2.title': 'Synergieffekten — Bedre sammen',
  'scienceInside.bundle.card2.subtitle': 'Kumulative resultater som forsterkes over tid',
  'scienceInside.bundle.card2.point1': 'Bruk av alle tre produktene skaper en kumulativ effekt — resultatene bygger på hverandre',
  'scienceInside.bundle.card2.point2': 'PDRN i hvert trinn betyr jevn cellefornyelse gjennom hele rutinen',
  'scienceInside.bundle.card2.point3': 'Ulike leveringsmetoder (maske, serum, krem) sikrer at ingrediensene når alle lag av huden',
  'scienceInside.bundle.card2.point4': 'Kunder rapporterer betydelig raskere resultater med den komplette rutinen',
  'scienceInside.bundle.card3.title': '24-timers dekning — Dag og natt',
  'scienceInside.bundle.card3.subtitle': 'Huden din er aldri ubeskyttet',
  'scienceInside.bundle.card3.point1': 'Morgen: Serum under sminke for fuktighet, beskyttelse og glød hele dagen',
  'scienceInside.bundle.card3.point2': 'Kveld: Sheet-maske for dyp rensing og næring (2–3 ganger i uken)',
  'scienceInside.bundle.card3.point3': 'Natt: Krem med kapsler med gradvis frigjøring som virker mens du sover',
  'scienceInside.bundle.card3.point4': 'Resultatet: fornyelse døgnet rundt — huden din forbedres 24/7',

  // What is PDRN
  'whatIsPDRN.title': 'Hva er PDRN?',
  'whatIsPDRN.subtitle': 'Den revolusjonerende ingrediensen som forandrer hudpleieverdenen — fra klinikken til hjemmet',
  'whatIsPDRN.origin.title': 'Utvinnet fra lakse-DNA',
  'whatIsPDRN.origin.subtitle': 'En bevist ingrediens innen estetisk medisin',
  'whatIsPDRN.origin.point1': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele verden',
  'whatIsPDRN.origin.point1.US': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele USA',
  'whatIsPDRN.origin.point1.GB': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Storbritannia',
  'whatIsPDRN.origin.point1.AU': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Australia',
  'whatIsPDRN.origin.point1.IL': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Israel',
  'whatIsPDRN.origin.point1.NO': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Norge',
  'whatIsPDRN.origin.point1.FR': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Frankrike',
  'whatIsPDRN.origin.point1.DE': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Tyskland',
  'whatIsPDRN.origin.point1.ES': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Spania',
  'whatIsPDRN.origin.point1.HR': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Kroatia',
  'whatIsPDRN.origin.point1.FI': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele Finland',
  'whatIsPDRN.origin.point1.AE': 'PDRN (polydeoksyribonukleotid) utvinnes fra lakse-DNA — et biokompatibelt molekyl brukt i dermatologiske klinikker over hele De forente arabiske emirater',
  'whatIsPDRN.origin.point2': 'Støttet av kliniske studier med målbare resultater innen fuktighet og elastisitet',
  'whatIsPDRN.origin.point3': 'Naturlig regenerativ forbindelse — uten syntetiske fyllstoffer, uten sterke kjemikalier',
  'whatIsPDRN.howItWorks.title': 'Regenerasjon på cellenivå',
  'whatIsPDRN.howItWorks.subtitle': 'Virker der andre produkter ikke når',
  'whatIsPDRN.howItWorks.point1': 'Aktiverer adenosin A2A-reseptoren — utløser hudens naturlige reparasjons- og fornyelsesprosess',
  'whatIsPDRN.howItWorks.point2': 'Fremmer kollagen- og elastinproduksjon innenfra, ikke bare overfladisk fuktighet',
  'whatIsPDRN.howItWorks.point3': 'Reduserer betennelse og beroliger stresset hud for en sunnere og mer balansert hud',
  'whatIsPDRN.results.title': 'Kliniske resultater hjemme',
  'whatIsPDRN.results.subtitle': 'Inntil nylig — bare på klinikker',
  'whatIsPDRN.results.point1': 'Inntil nylig var PDRN-behandlinger kun tilgjengelige på eksklusive dermatologiklinikker til høye priser',
  'whatIsPDRN.results.point2': 'Formlene våre leverer samme aktive ingrediens i et daglig format du kan påføre hjemme',
  'whatIsPDRN.results.point3': '+100 % forbedring i fuktighet målt klinisk — synlig forbedring allerede fra første påføring',

  // Proven Results
  'provenResults.title': 'Beviste resultater',
  'provenResults.stat1.value': '+100 %',
  'provenResults.stat1.label': 'Forbedret fuktighet',
  'provenResults.stat1.sub': 'Klinisk målt',
  'provenResults.stat2.value': '93 %',
  'provenResults.stat2.label': 'Glattere hud',
  'provenResults.stat2.sub': 'Rapportert innen 4 uker',
  'provenResults.stat3.value': '4.9/5',
  'provenResults.stat3.label': 'Kundevurdering',
  'provenResults.stat3.sub': 'Gjennomsnitt for alle produkter',
  'provenResults.stat4.value': '+10 000',
  'provenResults.stat4.label': 'Fornøyde kunder',
  'provenResults.stat4.sub': 'Over hele verden',
  'provenResults.stat4.sub.US': 'Over hele USA',
  'provenResults.stat4.sub.GB': 'Over hele Storbritannia',
  'provenResults.stat4.sub.AU': 'Over hele Australia',
  'provenResults.stat4.sub.IL': 'Over hele Israel',
  'provenResults.stat4.sub.NO': 'Over hele Norge',
  'provenResults.stat4.sub.FR': 'Over hele Frankrike',
  'provenResults.stat4.sub.DE': 'Over hele Tyskland',
  'provenResults.stat4.sub.ES': 'Over hele Spania',
  'provenResults.stat4.sub.HR': 'Over hele Kroatia',
  'provenResults.stat4.sub.FI': 'Over hele Finland',
  'provenResults.stat4.sub.AE': 'Over hele De forente arabiske emirater',

  // Comparison Table
  'comparison.title': 'PDRN kontra vanlig hudpleie',
  'comparison.headerRegular': 'Vanlig hudpleie',
  'comparison.headerPDRN': 'PDRN SKIN',
  'comparison.row1.criteria': 'Virkemåte',
  'comparison.row1.regular': 'Overfladisk fuktighet',
  'comparison.row1.pdrn': 'Regenerasjon på cellenivå',
  'comparison.row2.criteria': 'Aktiv ingrediens',
  'comparison.row2.regular': 'Generiske peptider',
  'comparison.row2.pdrn': 'PDRN (lakse-DNA)',
  'comparison.row3.criteria': 'Resultater',
  'comparison.row3.regular': 'Uker før man ser noe',
  'comparison.row3.pdrn': 'Synlig allerede fra første bruk',
  'comparison.row4.criteria': 'Teknologi',
  'comparison.row4.regular': 'Hylleformler',
  'comparison.row4.pdrn': 'Teknologi på klinisk nivå',
  'comparison.row5.criteria': 'Klinisk bevis',
  'comparison.row5.regular': 'Markedsføringspåstander',
  'comparison.row5.pdrn': 'Klinisk testet +100 % fuktighet',

  // FAQ
  'faq.sectionTitle': 'Vanlige spørsmål',

  // 404
  '404.title': 'Siden ble ikke funnet',
  '404.subtitle': 'Siden du leter etter finnes ikke eller har blitt flyttet.',
  '404.backHome': 'Tilbake til forsiden',
  '404.popularProducts': 'Populære produkter',

  // Product Disclaimer & Misc
  'product.disclaimer': '*Bildene er kun til illustrasjonsformål. Resultatene kan variere fra person til person avhengig av hudtype og bruk. Produktet er ikke ment for diagnostisering, behandling eller forebygging av medisinske tilstander. Det anbefales å gjøre en følsomhetstest på et skjult område før første fullstendige bruk. Ved følsomhet, avbryt bruken. Ved alvorlig følsomhet, oppsøk lege. Leverandøren kan endre produktemballasje og form fra tid til annen; produktet er det samme.',
  'product.shippingMarquee': 'Gratis frakt på bestillinger over {amount} i hele Norge',
  'product.inStockReady': 'På lager og klar for umiddelbar levering',

  // Terms agreement
  'product.termsAgreementBefore': 'Ved å bruke og handle på denne siden godtar du ',
  'product.termsLink': 'vilkårene for bruk',
  'product.termsAgreementAfter': '',

  // Announcement
  'announcement.freeShipping': '✨ Gratis frakt på bestillinger over {amount} i hele Norge',
  'announcement.close': 'Lukk',
  'urgency.limitedOffer': 'Begrenset tilbud',
  'urgency.endsIn': 'Slutter om',

  // Blog
  'blog.title': 'Blogg',
  'blog.subtitle': 'Profesjonelle hudpleieguider, PDRN-vitenskap og tips fra koreansk hudpleie',
  'blog.metaDescription': 'Les våre profesjonelle guider om PDRN-hudpleie, lakse-DNA-vitenskap, Glass Skin-rutiner og tips fra koreansk hudpleie.',
  'blog.readMore': 'Les mer',
  'blog.minRead': 'min lesing',
  'blog.badge': 'Vitenskapelig hudpleie',
  'blog.chip.antiAging': 'Anti-aldring',
  'blog.chip.hydration': 'Fuktighet',
  'blog.chip.sensitiveSkin': 'Sensitiv hud',
  'blog.chip.nightRoutine': 'Kveldsrutine',
  'blog.chip.ingredients': 'Ingredienser',
  'blog.chip.layering': 'Layering',
  'blog.chip.glassSkin': 'Glass Skin',
  'blog.chip.pdrnScience': 'PDRN-vitenskap',
  'blog.relatedArticles': 'Relaterte artikler',
  'blog.recommendedProducts': 'Anbefalte produkter',
  'blog.latestArticles': 'Nytt fra bloggen vår',
  'blog.latestSubtitle': 'Profesjonelle PDRN-hudpleieguider og tips fra koreansk hudpleie',
  'blog.viewAll': 'Se alle artikler',
  'blog.statsArticles': 'Artikler',
  'blog.statsLanguages': 'Språk',
  'blog.statsVersions': 'Oversatte versjoner',
  'blog.availableIn': 'Tilgjengelig på 11 språk',
  'blog.avgReadTime': 'Gj.snitt 5 min lesing',

  // SEO meta (homepage)
  'seo.homeTitle': 'PDRN Hudpleie | Koreansk Lakse-DNA Serum, Masker & Krem | Glass Skin',
  'seo.homeDescription': 'PDRN hudpleie med koreansk lakse-DNA-teknologi. PDRN-serum, sheet-masker og kapsulkrem for Glass Skin-effekten. Klinisk bevist med gratis frakt.',

  // SEO product titles & descriptions
  'seo.productTitle.pink-glow-serum-with-pdrn-peptides': 'PDRN Serum med Lakse-DNA & Peptider | PDRN Hudpleie',
  'seo.productDescription.pink-glow-serum-with-pdrn-peptides': 'Kjøp PDRN-serum med lakse-DNA og peptider. Koreansk Glass Skin serum som styrker kollagen og glatter rynker. PDRN hudpleie med gratis frakt.',
  'seo.productTitle.pdrn-pink-sheet-masks-10-pack': 'PDRN Sheet-Masker 10-pakning | Koreanske Lakse-DNA Masker | PDRN Hudpleie',
  'seo.productDescription.pdrn-pink-sheet-masks-10-pack': 'Kjøp PDRN sheet-masker dyppet i lakse-DNA-serum. 10 koreanske ansiktsmasker for Glass Skin-effekten med PDRN, Vitamin B12 & Niacinamid.',
  'seo.productTitle.smart-capsule-cream-with-collagen': 'PDRN Kapsulkrem med Kollagen | Koreansk Hudpleie | PDRN Hudpleie',
  'seo.productDescription.smart-capsule-cream-with-collagen': 'Kjøp PDRN-kapsulkrem med kollagen og niacinamid. Koreansk anti-aging krem med lakse-DNA-teknologi for dyp fuktighet og fasthet.',
  'seo.productTitle.complete-pdrn-trio-bundle': 'Komplett PDRN Hudpleiesett — Serum, Masker & Krem | PDRN Hudpleie',
  'seo.productDescription.complete-pdrn-trio-bundle': 'Kjøp det komplette PDRN-hudpleiesettet med serum, 10 masker og krem. Spar opptil 53% på koreansk lakse-DNA-hudpleie.',

  // Internal linking
  'seo.explorePDRN': 'Utforsk PDRN hudpleie',
  'seo.anchor.serumBenefits': 'Fordeler med PDRN-serum',
  'seo.anchor.howPDRNWorks': 'Hvordan PDRN virker',
  'seo.anchor.masksVsTraditional': 'PDRN-masker vs. tradisjonelle',
  'seo.anchor.glassSkinGuide': 'Glass Skin-guide',
  'seo.anchor.koreanSecret': 'Koreansk hudpleiehemmelighet',
  'seo.anchor.pdrnVsRegular': 'PDRN vs. vanlig hudpleie',
};
